import request from '@/utils/request'

export function getCardList(params) {
  return request({
    url: '/api/associate/member/card/index',
    method: 'get',
    params
  })
}
export function giveCard(data) {
  return request({
    url: '/api/associate/member/card/give',
    method: 'post',
    data
  })
}
export function getUserInfo(params) {
  return request({
    url: 'api/associate/userInfo',
    method: 'get',
    params
  })
}

